<template>
    <div>
        <Header></Header>
        <main id="content" role="main">
            <div class="
          container
          space-top-3 space-top-lg-2 space-bottom-1 space-bottom-md-2
        " style="background-color:#f8f9fB">
                <div class="w-md-80 w-lg-75 text-center mx-md-auto">
                    <h2 class="display-5" style="font-weight:600">合作伙伴</h2>
                    <p class="lead" style="font-size:1.05rem;font-weight:549">
                        秉承“耕耘收获、共赢共创”的理念，实现双赢经营策略
                    </p>
                </div>
            </div>
            <!-- Works Section -->
            <div class="dzsparallaxer auto-init height-is-based-on-content use-loading mode-scroll bg-white mt-5" data-options='{direction: "reverse"}'>
                <div class="dzsparallaxer--target" :class="show?'dzsparallaxer--target1':''">
                    <div class="container-fluid px-lg-6">
                        <div class="row justify-content-center">
                            <div class="col-3 my-4" data-parallaxanimation='[{property: "transform", value:" translate3d(0,`${val}`rem,0)", initial:"15", mid:"0", final:"-15"}]'>
                                <!-- Logo -->
                                <div class="d-none d-md-block bg-white avatar avatar-xl shadow-sm rounded-circle p-4 mx-auto">
                                    <img class="avatar-img" src="@/assets/images/hezuo/logo1.png" alt="Image Description">
                                </div>
                                <!-- End Logo -->
                            </div>
                            <div class="col-3 mb-4" data-parallaxanimation='[{property: "transform", value:" translate3d(0,`${val}`rem,0)", initial:"5", mid:"0", final:"-5"}]'>
                                <!-- Logo -->
                                <div class="d-block bg-white avatar avatar-xl shadow-sm rounded-circle p-4 mx-auto">
                                    <img class="avatar-img" src="@/assets/images/hezuo/logo2.png" alt="Image Description">
                                </div>
                                <!-- End Logo -->
                            </div>
                            <div class="col-3 my-4" data-parallaxanimation='[{property: "transform", value:" translate3d(0,`${val}`rem,0)", initial:"11", mid:"0", final:"-11"}]'>
                                <!-- Logo -->
                                <div class="d-none d-md-block bg-white avatar avatar-xl shadow-sm rounded-circle p-4 mx-auto">
                                    <img class="avatar-img" src="@/assets/images/hezuo/logo3.png" alt="Image Description">
                                </div>
                                <!-- End Logo -->
                            </div>
                        </div>

                        <div class="row justify-content-between">
                            <div class="col-3 mb-4" data-parallaxanimation='[{property: "transform", value:" translate3d(0,`${val}`rem,0)", initial:"7", mid:"0", final:"-7"}]'>
                                <!-- Logo -->
                                <div class="d-block bg-white avatar avatar-xl shadow-sm rounded-circle p-4">
                                    <img class="avatar-img" src="@/assets/images/hezuo/logo4.png" alt="Image Description">
                                </div>
                                <!-- End Logo -->
                            </div>
                            <div class="col-3 my-4" data-parallaxanimation='[{property: "transform", value:" translate3d(0,`${val}`rem,0)", initial:"7", mid:"0", final:"-7"}]'>
                                <!-- Logo -->
                                <div class="d-block bg-white avatar avatar-xl shadow-sm rounded-circle p-4 ml-auto">
                                    <img class="avatar-img" src="@/assets/images/hezuo/logo5.png" alt="Image Description">
                                </div>
                                <!-- End Logo -->
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-3 offset-1 my-4" data-parallaxanimation='[{property: "transform", value:" translate3d(0,`${val}`rem,0)", initial:"15", mid:"0", final:"-15"}]'>
                                <!-- Logo -->
                                <div class="d-none d-md-block bg-white avatar avatar-xl shadow-sm rounded-circle p-4 ml-auto">
                                    <img class="avatar-img" src="@/assets/images/hezuo/logo6.png" alt="Image Description">
                                </div>
                                <!-- End Logo -->
                            </div>
                            <div class="col-3 offset-2 my-4" data-parallaxanimation='[{property: "transform", value:" translate3d(0,`${val}`rem,0)", initial:"11", mid:"0", final:"-11"}]'>
                                <!-- Logo -->
                                <div class="d-none d-md-block bg-white avatar avatar-xl shadow-sm rounded-circle p-4 ml-auto">
                                    <img class="avatar-img" src="@/assets/images/hezuo/logo7.png" alt="Image Description">
                                </div>
                                <!-- End Logo -->
                            </div>
                        </div>

                        <div class="row justify-content-between">
                            <div class="col-4" data-parallaxanimation='[{property: "transform", value:" translate3d(0,`${val}`rem,0)", initial:"11", mid:"0", final:"-11"}]'>
                                <div class="d-block bg-white avatar avatar-xl shadow-sm rounded-circle p-4 mx-auto">
                                    <img class="avatar-img" src="@/assets/images/hezuo/logo8.png" alt="Image Description">
                                </div>
                            </div>
                            <div class="col-4 mt-6" data-parallaxanimation='[{property: "transform", value:" translate3d(0,`${val}`rem,0)", initial:"5", mid:"0", final:"-5"}]'>
                                <div class="d-none d-sm-block bg-white avatar avatar-xl shadow-sm rounded-circle p-4 mx-auto">
                                    <img class="avatar-img" src="@/assets/img/160x160/img10.jpg" alt="Image Description">
                                </div>
                            </div>
                            <div class="col-4 mt-6" data-parallaxanimation='[{property: "transform", value:" translate3d(0,`${val}`rem,0)", initial:"15", mid:"0", final:"-15"}]'>
                                <div class="d-block bg-white avatar avatar-xl shadow-sm rounded-circle p-4 mx-auto">
                                    <img class="avatar-img" src="@/assets/images/hezuo/logo9.png" alt="Image Description">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container space-3 space-sm-4 position-relative z-index-2">
                    <!-- Title -->
                    <div class="w-md-80 w-lg-65 text-center mx-md-auto">
                        <h2 class="display-5" style="font-weight:600">用户为本 携手共进</h2>
                        <p style="color:#212529;" class="mt-3">伴随用户需求不断更新，技术不断发展，行业的商业模式、发展战略等都在迅速变化与进步着，创联天成希望为用户提供更好的产品和服务、持续提升生产效率和品质，与客户共成长。</p>
                        
                        <router-link class="font-weight-bold" to="/case" >客户案例 </router-link>&nbsp;&nbsp;<span style="color:#efefef">|</span>&nbsp;&nbsp;
                        <router-link class="font-weight-bold" to="/contact" >联系我们</router-link>
                    </div>
                    <!-- End Title -->
                </div>

                <div class="position-absolute top-0 left-0 w-100 h-100 gradient-y-lg-white"></div>
            </div>
            <!-- End Works Section -->
            <!-- Clients Section -->
            <div class="container space-1">
                <div class="w-lg-100 mx-lg-auto">
                    <div class="text-center mb-4">
                        <h2 class="divider divider-text">服务客户 / Customer</h2>
                    </div>
                    <div class="row justify-content-between text-center">
                        <div class="col-0 col-lg-1">
                           
                        </div>
                        <div class="col-4 col-lg-2 mb-5 mb-lg-0 logo-cz-center">
                            <div class="mx-3 ">
                                <img  src="@/assets/images/hezuo/1.png" alt="Image Description">
                            </div>
                        </div>
                        <div class="col-4 col-lg-2 mb-5 mb-lg-0 logo-cz-center">
                            <div class="mx-3">
                                <img  src="@/assets/images/hezuo/2.png" alt="Image Description">
                            </div>
                        </div>
                        <div class="col-4 col-lg-2 mb-5 mb-lg-0 logo-cz-center">
                            <div class="mx-3">
                                <img  src="@/assets/images/hezuo/3.png" alt="Image Description">
                            </div>
                        </div>
                        <div class="col-4 col-lg-2 logo-cz-center">
                            <div class="mx-3">
                                <img  src="@/assets/images/hezuo/4.png" alt="Image Description">
                            </div>
                        </div>
                        <div class="col-4 col-lg-2 logo-cz-center">
                            <div class="mx-3">
                                <img  src="@/assets/images/hezuo/5.png" alt="Image Description">
                            </div>
                        </div>
                        <div class="col-0 col-lg-1">
                           
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Clients Section -->
            <!-- Clients Section -->
            <div class="container space-1 space-bottom-3">
                <div class="w-lg-100 mx-lg-auto">
                    <div class="text-center mb-4">
                        <h2 class="divider divider-text">合作伙伴 / Cooperation</h2>
                    </div>

                     <div class="row justify-content-between text-center">
                        <div class="col-0 col-lg-1">
                           
                        </div>
                        <div class="col-4 col-lg-2 mb-5 mb-lg-0 logo-cz-center">
                            <div class="mx-3 ">
                                <img  src="@/assets/images/hezuo/6.png" alt="Image Description">
                            </div>
                        </div>
                        <div class="col-4 col-lg-2 mb-5 mb-lg-0 logo-cz-center">
                            <div class="mx-3">
                                <img  src="@/assets/images/hezuo/7.png" alt="Image Description">
                            </div>
                        </div>
                        <div class="col-4 col-lg-2 mb-5 mb-lg-0 logo-cz-center">
                            <div class="mx-3">
                                <img  src="@/assets/images/hezuo/8.png" alt="Image Description">
                            </div>
                        </div>
                        <div class="col-4 col-lg-2 logo-cz-center">
                            <div class="mx-3">
                                <img  src="@/assets/images/hezuo/9.png" alt="Image Description">
                            </div>
                        </div>
                        <div class="col-4 col-lg-2 logo-cz-center">
                            <div class="mx-3">
                                <img  src="@/assets/images/hezuo/10.png" alt="Image Description">
                            </div>
                        </div>
                        <div class="col-0 col-lg-1">
                           
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Clients Section -->
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'
import '@/assets/vendor/jquery/dist/jquery.min.js'
import '@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js'

import '@/assets/vendor/font-awesome/css/all.min.css'
import '@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css'
import '@/assets/css/theme.css'
import '@/assets/vendor/hs-header/dist/hs-header.min.js'
import '@/assets/vendor/hs-go-to/dist/hs-go-to.min.js'
import '@/assets/vendor/hs-unfold/dist/hs-unfold.min.js'
import '@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js'
import '@/assets/vendor/hs-show-animation/dist/hs-show-animation.min.js' //8.
import '@/assets/vendor/jquery-validation/dist/jquery.validate.min.js' //9.

import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '@/assets/js/hs.core.js'
import '@/assets/js/hs.validation.js' // 11.
import '@/assets/vendor/dzsparallaxer/dzsparallaxer.css'
import '@/assets/vendor/dzsparallaxer/dzsparallaxer.js'
export default {
    components: { Header, Footer },
    data() {
        return {
            show: false,
        }
    },
    mounted() {
        setTimeout(() => {
            this.show = true
        }, 200)

        $(document).ready(function () {
            // var header = new HSHeader($("#header")).init();

            // initialization of mega menu
            var megaMenu = new HSMegaMenu($('.js-mega-menu'), {
                desktop: {
                    position: 'left',
                },
            }).init()

            // initialization of unfold
            var unfold = new HSUnfold('.js-hs-unfold-invoker').init()

            $('.js-animation-link').each(function () {
                var showAnimation = new HSShowAnimation($(this)).init()
            })

            // initialization of form validation
            $('.js-validate').each(function () {
                $.HSCore.components.HSValidation.init($(this), {
                    rules: {
                        confirmPassword: {
                            equalTo: '#signupPassword',
                        },
                    },
                })
            })

            // initialization of video player
            $('.js-inline-video-player').each(function () {
                var videoPlayer = new HSVideoPlayer($(this)).init()
            })

            // initialization of go to
            $('.js-go-to').each(function () {
                var goTo = new HSGoTo($(this)).init()
            })
        })
    },
}
</script>

<style scoped>
.dzsparallaxer--target1 {
    opacity: 1 !important;
    visibility: visible !important;
    transform: 2s;
}

.logo-cz-center {
    display: flex;
    align-items: center;
}
.img-width {
    max-width: 12rem;
}
.flex-center {
    display: flex;
    align-items: center;
    flex: 1;
}
.he-div {
    display: flex;
    justify-content: space-between;
}
.yincang {
    visibility: hidden;
}
.chongxie {
    width: 832px;
    display: inline-block;
    white-space: nowrap;
}
.chongxie .one {
    margin-top: 6px;
}
</style>


// WEBPACK FOOTER //
// src/view/hezuoPeople.vue